import { useState } from "react";

const LOC1 = {
  img: "/img/aerial.jpg", w: 985, h: 651, badge: "12.62 AC · 549,727 SF", stroke: 4, scale: 1, testid: "parcel-aerial", badgePos: "right-4 top-4",
  shapes: [
    { id: "906-171-005", acres: 9.9, pts: "613,648 308,245 418,138 428,151 446,134 691,457 708,479 741,523 725,539", fill: "#2D6E6A", lx: 515, ly: 395 },
    { id: "906-171-001", acres: 2.72, pts: "691,457 446,134 486,95 764,386", fill: "#17324D", lx: 770, ly: 215, leader: [605, 270] },
  ],
};

const LOC2 = {
  img: "/img/location2.jpg", w: 2298, h: 1761, badge: "4.32 AC · 188,179 SF", stroke: 11, scale: 1.9, testid: "parcel-aerial-2", badgePos: "left-4 top-4",
  shapes: [
    { id: "l2-a", acres: 1.73, pts: "817,390 818,123 866,75 1235,78 1234,391", fill: "#2D6E6A", lx: 1026, ly: 248 },
    { id: "l2-b", acres: 1.58, pts: "1234,391 1235,78 1744,81 1743,172 1714,172 1664,186 1627,213 1540,298 1448,392", fill: "#17324D", lx: 1420, ly: 225 },
    { id: "l2-c", acres: 1.01, pts: "872,574 868,561 861,550 852,539 841,530 830,524 817,518 817,390 1234,391 1233,587 1207,582 1181,578 1155,577", fill: "#3E8A84", lx: 1026, ly: 500 },
  ],
};

const Label = ({ p, active, k }) => (
  <g transform={`translate(${p.lx},${p.ly}) scale(${k})`} className="pointer-events-none">
    <rect x={-72} y={-22} width={144} height={44} rx={10} fill={active ? "#0F2235" : "rgba(255,255,255,0.94)"} />
    <text y={8} textAnchor="middle" fontFamily="Newsreader" fontSize={21} fill={active ? "#fff" : "#17324D"}>{`${p.acres.toFixed(2)} acres`}</text>
  </g>
);

export const ParcelAerial = ({ location = 1 }) => {
  const [active, setActive] = useState(null);
  const L = location === 1 ? LOC1 : LOC2;
  return (
    <div className="relative" data-testid={L.testid}>
      <img data-testid={location === 1 ? "property-aerial" : "property-aerial-2"} src={L.img} alt="Site aerial with parcel outlines" className="w-full object-cover" style={{ aspectRatio: `${L.w}/${L.h}` }} />
      <svg viewBox={`0 0 ${L.w} ${L.h}`} preserveAspectRatio="none" className="absolute inset-0 h-full w-full">
        {L.shapes.map((p) => (
          <polygon
            key={p.id}
            data-testid={`parcel-shape-${p.id}`}
            points={p.pts}
            fill={p.fill}
            fillOpacity={active === p.id ? 0.5 : 0.28}
            stroke="#fff"
            strokeWidth={L.stroke}
            strokeLinejoin="round"
            className="cursor-pointer transition-[fill-opacity] duration-300"
            onMouseEnter={() => setActive(p.id)}
            onMouseLeave={() => setActive(null)}
          />
        ))}
        {L.shapes.filter((p) => p.leader).map((p) => (
          <g key={p.id} className="pointer-events-none">
            <line x1={p.leader[0]} y1={p.leader[1]} x2={p.lx} y2={p.ly} stroke="#fff" strokeWidth={2} />
            <circle cx={p.leader[0]} cy={p.leader[1]} r={5} fill="#fff" />
          </g>
        ))}
        {L.shapes.map((p) => <Label key={p.id} p={p} k={L.scale} active={active === p.id} />)}
      </svg>
      <div data-testid={`${L.testid}-badge`} className={`absolute ${L.badgePos} rounded-full bg-white/95 px-3.5 py-1.5 text-[11px] font-mono tracking-[0.12em] text-ink shadow`}>
        {L.badge}
      </div>
    </div>
  );
};
